import { render } from "./Networks.vue?vue&type=template&id=20215d40"
import script from "./Networks.vue?vue&type=script&lang=js"
export * from "./Networks.vue?vue&type=script&lang=js"
script.render = render

export default script